import { signIn } from 'next-auth/react';
import { Button } from '@/lib/components/ui/button';
import { useTranslation } from 'next-i18next';
import useInvitation from 'hooks/useInvitation';
import env from '@/lib/env';
import { Github } from 'lucide-react';

const GithubButton = () => {
  const { t } = useTranslation('common');
  const { invitation } = useInvitation();

  const callbackUrl = invitation
    ? `/invitations/${invitation.token}`
    : env.redirectIfAuthenticated;

  return (
    <Button
      variant="outline"
      className="w-full"
      onClick={() => {
        signIn('github', {
          callbackUrl,
        });
      }}
    >
      <Github className="mr-2 h-4 w-4" />
      {t('continue-with-github')}
    </Button>
  );
};

export default GithubButton;
